import React, {Component} from "react";
import Xhr from "../../helpers/Xhr";
import EventsById from "../../components/EventById/EventsById";
import Breadcumbs from "../../components/Breadcumbs";
import {connect} from "react-redux";

class LineLeagues extends Component {
	state = {
		data     : {
			events  : [],
			factors : [],
			leagues : [],
			results : [],
			sports  : [],
		},
		fetching : true
	};

	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.loadData({...this.props});
	}

	componentWillReceiveProps(nextProps) {
		this.loadData({...nextProps});
	}

	loadData(data) {
		if ( data.several !== null ) {
			Xhr.getLineDataSeveral(data.several).then((resp) => this.setState({
				data     : resp.data,
				fetching : false
			}));
		}
		else if ( data.sport_slug !== null ) {
			Xhr.getPopularLineData(data.sport_slug, data.popular_slug, data.filter.linePeriod).then((resp) => this.setState({
				data     : resp.data,
				fetching : false
			}));
		}
		else {
			Xhr.getLineData(data.leagues, data.event_id, data.sports, data.filter.linePeriod).then((resp) => {
				this.setState({
					data     : resp.data,
					fetching : false
				})
			});
		}
	}

	getBreadcumbs() {
		let data = [];

		data.push({
			key   : 'Главная',
			value : ''
		});

		if ( this.state.data.sports.length === 1 ) {
			const sport = this.state.data.sports[0];
			data.push({
				key   : sport.name,
				value : `/line-select/${sport.id}`
			});
		}

		if ( this.state.data.leagues.length === 1 ) {
			const league = this.state.data.leagues[0];
			data.push({
				key   : league.name,
				value : ''
			});
		}

		return data;
	}

	render() {
		const breadcumbs = this.getBreadcumbs();

		return (
			<div className="body__container__side-right event">
				{/*BREADCUMBS*/}
				<Breadcumbs data={breadcumbs}/>

				<EventsById type="line" data={this.state.data} {...this.props} />
			</div>
		);
	}
}

export default connect(
	state => ({
		filter : state.filter
	}),
	dispatch => ({})
)(LineLeagues);


// WEBPACK FOOTER //
// ./src/app/pages/LineLeagues/LineLeagues.js